import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    ADD_TASK: (task) => ({ task }),
    API: {
      ADD_TASK: apiResourceActionCreator('task')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/tasks`, authToken, payload.task, actions.admin.api.addTask);

function* addTask(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'addTask',
  action: actions,
  sagas: addTask,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdatingTask: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isUpdatingTask: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isUpdatingTask: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/addTask.js